export default __webpack_public_path__ + "static/media/1358.e21ecd22.png";